import Web3Contract from 'web3-eth-contract'

import { useWalletStore } from '@/store'

class Contract {
  constructor(contractAddress, contractAbi) {
    const contract = new Web3Contract(contractAbi, contractAddress)

    contract.setProvider(window.ethereum)
    contract.options.address = contractAddress

    this.contract = contract

    return this
  }

  async send(methodName, args = [], sendValue = null) {
    const walletStore = useWalletStore()

    let sendData = { from: walletStore.address }

    if (sendValue) {
      sendData.value = sendValue
    }

    let result = await this.contract.methods[methodName](...args).send(sendData)

    return result
  }

  async call(methodName, args = []) {
    const result = await this.contract.methods[methodName](...args).call()
    return result
  }

  async getPastEvents(eventName, args = {}) {
    const result = await this.contract.getPastEvents(eventName, args)

    return result
  }
}

export default Contract